<template>
  <div class="client">
    <section id="client" class="gallery section">
      <div class="container section-title" data-aos="fade-up">
        <h2>{{titleClient}}</h2>
      </div>

      <div class="container" data-aos="fade-up" data-aos-delay="100">
        <div class="row g-4 justify-content-center">          
          <div class="col-lg-2 col-md-3 col-sm-4 col-4" v-for="item in dataClient" :key="item.id">
            <a class="glightbox" data-gallery="images-gallery" :href="gambarUrl + item.client">
              <img :src="gambarUrl + item.client" class="img-fluid" alt="Client">
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ClientJs from './js/app.js';
export default ClientJs;
</script>
